var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "registration-form",
      attrs: { action: _vm.action, method: "POST" },
      on: {
        submit: function($event) {
          _vm.onSubmit($event)
        }
      }
    },
    [
      _c(
        "md-card",
        [
          _c("md-card-header", [
            _c("div", {
              staticClass: "md-title md-title-dark",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "registration.password-creation-" + _vm.registrationType,
                    { days: _vm.discoveryDays }
                  )
                )
              }
            })
          ]),
          _vm._v(" "),
          _c("md-card-content", [
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "md-field",
                  { class: { "md-invalid": !!_vm.errors["password"] } },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("registration.password")))
                    ]),
                    _vm._v(" "),
                    _c("md-input", {
                      attrs: {
                        type: "password",
                        name: "password",
                        disabled: _vm.submitting ? "disabled" : null,
                        required: ""
                      },
                      on: {
                        focus: function($event) {
                          _vm.passwordFieldFocused = true
                          _vm.passwordFieldTouched = true
                        },
                        blur: function($event) {
                          _vm.passwordFieldFocused = false
                        }
                      },
                      model: {
                        value: _vm.fData.password,
                        callback: function($$v) {
                          _vm.$set(_vm.fData, "password", $$v)
                        },
                        expression: "fData.password"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.passwordFieldFocused,
                            expression: "passwordFieldFocused"
                          }
                        ],
                        staticClass: "md-helper-text"
                      },
                      [_vm._v(_vm._s(_vm.$t("validation.passwordrules")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "md-error" }, [
                      _vm._v(
                        _vm._s(
                          _vm.errors["password"]
                            ? _vm.errors["password"][0]
                            : ""
                        )
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "md-field",
                  {
                    class: {
                      "md-invalid": !!_vm.errors["password_confirmation"]
                    }
                  },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("registration.password-confirmation"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("md-input", {
                      attrs: {
                        type: "password",
                        name: "password_confirmation",
                        disabled: _vm.submitting ? "disabled" : null,
                        required: ""
                      },
                      model: {
                        value: _vm.fData.password_confirmation,
                        callback: function($$v) {
                          _vm.$set(_vm.fData, "password_confirmation", $$v)
                        },
                        expression: "fData.password_confirmation"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "md-error" }, [
                      _vm._v(
                        _vm._s(
                          _vm.errors["password_confirmation"]
                            ? _vm.errors["password_confirmation"][0]
                            : ""
                        )
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("submit-button", {
        staticClass: "registration-standalone-button",
        attrs: {
          type: "submit",
          submitting: _vm.submitting,
          label: _vm.$t("registration.create-password"),
          dusk: "create-password-button"
        },
        on: {
          click: function($event) {
            _vm.onSubmit()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73aaa11f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73aaa11f","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/PasswordFormComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-73aaa11f","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/PasswordFormComponent.vue
// module chunks = 1 2 3